import { Stack, Text, Heading, Link, Box, Tiles } from 'braid-design-system';

import { alliances } from './data';

const Alliances = () => (
  <Stack space="large">
    <Stack space="medium">
      <Heading level="3" component="h2">
        Leadership and community
      </Heading>
      <Text>
        SEEK Business is committed to improving our industry and fostering best
        practices so that both franchisors and franchisees benefit. We often run
        joint events with the following industry leaders to facilitate
        networking and learning that will benefit the whole franchising
        community.
      </Text>
    </Stack>

    <Tiles space="xsmall" columns={{ mobile: 1, tablet: 3 }}>
      {alliances().map((card, index) => (
        <Link key={index} href={card.url}>
          <Box
            height="full"
            padding="medium"
            borderRadius="large"
            boxShadow="borderNeutralLight"
          >
            <Stack space="medium">
              <Box style={{ minHeight: 120 }}>
                <img
                  src={card.imageUrl}
                  alt=""
                  style={{ width: '100%', height: 'auto' }}
                />
              </Box>
              <Heading level="4">{card.title}</Heading>
              <Text>{card.description}</Text>
            </Stack>
          </Box>
        </Link>
      ))}
    </Tiles>
  </Stack>
);

export default Alliances;
